import React from "react";
import { Grid, TextField } from "@mui/material";
import { SimpleSelect, BILLING_CODE_OPTIONS } from "./clientFormHelpers";

const BillingStep = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Name" name="billingName" value={formData.billingName} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Contact" name="billingContact" value={formData.billingContact} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Address" name="billingAddress" value={formData.billingAddress} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Address 2" name="billingAddress2" value={formData.billingAddress2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing City" name="billingCity" value={formData.billingCity} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing State" name="billingState" value={formData.billingState} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Zip" name="billingZip" value={formData.billingZip} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Country" name="billingCountry" value={formData.billingCountry} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Phone 1" name="billingPhone1" value={formData.billingPhone1} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Phone 2" name="billingPhone2" value={formData.billingPhone2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Fax" name="billingFax" value={formData.billingFax} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Email" name="billingEmail" value={formData.billingEmail} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Billing Format" name="billingFormat" value={formData.billingFormat} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SimpleSelect label="Billing Code" name="billingCode" value={formData.billingCode} onChange={handleChange} options={BILLING_CODE_OPTIONS} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Discount Percent" name="discountPercent" type="number" value={formData.discountPercent} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Surcharge Percent" name="surchargePercent" type="number" value={formData.surchargePercent} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="QB Account Number" name="qbAccountNumber" value={formData.qbAccountNumber} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Credit Amount" name="creditAmount" type="number" value={formData.creditAmount} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField label="Billing Comments" name="billingComments" value={formData.billingComments} onChange={handleChange} fullWidth size="small" multiline rows={2} />
      </Grid>
    </Grid>
  );
};

export default BillingStep;
